import "./App.css";
import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { initGA } from "./utils/analytics";
import RouteChangeListener from "./utils/RouteChangeListener";

import TopNav from "./components/shared/TopNav";
import Footer from "./components/shared/Footer";
import { SingleScreenLayout, DefaultLayout } from "./components/shared/Layouts";

import Home from "./pages/Home";
import HowItWorks from "./pages/HowItWorks";
import Contact from "./pages/Contact";
import Reservations from "./pages/Reservations";
import OrderSummary from "./pages/OrderSummary";
import About from "./pages/About";
import Storage from "./pages/Storage";
import NotFoundPage from "./pages/NotFoundPage";

import DebugLayout from "./pages/DebugLayout";
import { Amplify } from "aws-amplify";
import config from "./aws-exports";
Amplify.configure(config);

const initialReservationStages = [
  {
    id: "Step 1",
    name: "Select your tournament",
    status: "current",
    active: true,
  },
  {
    id: "Step 2",
    name: "Choose your package",
    status: "upcoming",
    active: false,
  },
  { id: "Step 3", name: "Select add-ons", status: "upcoming", active: false },
  {
    id: "Step 4",
    name: "Enter team details",
    status: "upcoming",
    active: false,
  },
  { id: "Step 5", name: "Checkout", status: "upcoming", active: false },
];

export default function App() {
  const [cart, setCart] = useState({
    tournament: {},
    package: {},
    addOns: [],
    team: {},
    discount: {},
  });
  const [searchQuery, setSearchQuery] = useState("");
  const [reservationStages, setReservationStages] = useState(
    initialReservationStages.map((s) => ({ ...s }))
  );

  useEffect(() => {
    initGA();
  }, []);

  return (
    <Router>
      <RouteChangeListener />

      <div className="grid grid-rows-[auto_1fr_auto] min-h-screen">
        <TopNav
          cart={cart}
          reservationStages={reservationStages}
          setCart={setCart}
          setReservationStages={setReservationStages}
        />
        <Routes>
          {/* Single screen layouts */}
          <Route
            path="/"
            element={
              <SingleScreenLayout>
                <Home
                  cart={cart}
                  reservationStages={reservationStages}
                  setCart={setCart}
                  setReservationStages={setReservationStages}
                  searchQuery={searchQuery}
                  setSearchQuery={setSearchQuery}
                />
              </SingleScreenLayout>
            }
          />
          <Route
            path="/home"
            element={
              <SingleScreenLayout>
                <Home
                  cart={cart}
                  reservationStages={reservationStages}
                  setCart={setCart}
                  setReservationStages={setReservationStages}
                  searchQuery={searchQuery}
                  setSearchQuery={setSearchQuery}
                />
              </SingleScreenLayout>
            }
          />
          <Route
            path="/contact"
            element={
              <SingleScreenLayout>
                <Contact />
              </SingleScreenLayout>
            }
          />
          {/* catch-all */}
          <Route
            path="*"
            element={
              <SingleScreenLayout>
                <NotFoundPage />
              </SingleScreenLayout>
            }
          />
          {/* Multi-screen layouts */}
          <Route
            path="/about"
            element={
              <DefaultLayout>
                <About />
              </DefaultLayout>
            }
          />
          <Route
            path="/storage"
            element={
              <DefaultLayout>
                <Storage />
              </DefaultLayout>
            }
          />
          <Route
            path="/reservations"
            element={
              <DefaultLayout>
                <Reservations
                  cart={cart}
                  reservationStages={reservationStages}
                  setCart={setCart}
                  setReservationStages={setReservationStages}
                  initialReservationStages={initialReservationStages}
                  searchQuery={searchQuery}
                  setSearchQuery={setSearchQuery}
                />
              </DefaultLayout>
            }
          />
          <Route
            path="/ordersummary"
            element={
              <DefaultLayout>
                <OrderSummary
                  setCart={setCart}
                  reservationStages={reservationStages}
                  setReservationStages={setReservationStages}
                  initialReservationStages={initialReservationStages}
                />
              </DefaultLayout>
            }
          />
          <Route
            path="/howitworks"
            element={
              <DefaultLayout>
                <HowItWorks
                  cart={cart}
                  reservationStages={reservationStages}
                  setCart={setCart}
                  setReservationStages={setReservationStages}
                  searchQuery={searchQuery}
                  setSearchQuery={setSearchQuery}
                />
              </DefaultLayout>
            }
          />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}
